import * as React from 'react';
import { Link as ReactLink } from 'react-router-dom';

import classNames from 'classnames';

import { getConfig, URLS } from '@constants';

import { ILinkProps, ILinkState } from './types';

import * as s from './Link.scss';

class LinkComponent extends React.PureComponent<ILinkProps, ILinkState> {

	state: ILinkState = {
		isNotLink: false,
	};

	componentDidMount(): void {
		this.setState({
			isNotLink: this.isCurrentPage(),
		});
	}

	componentDidUpdate(): void {
		this.setState({
			isNotLink: this.isCurrentPage(),
		});
	}

	isCurrentPage() {
		const { to } = this.props;

		return to === window.location.pathname && ![
			URLS.MAIN,
		].includes(to);
	}

	isExternalLink() {
		return /^(https?:\/\/|mailto:|javascript:)/.test(String(this.props.to));
	}

	render() {
		const { isNotLink } = this.state;
		const { className, to, onClick, isAlwaysLink, isSimpleLink: isSimple, ...props } = this.props;
		const isSimpleLink = isSimple || this.isExternalLink() || getConfig().isError;
		const linkProps = {
			className: classNames(s.block, className),
			onClick: onClick,
			...props,
		};
		const url = (isAlwaysLink && !to) ? '' : to;

		if ((!to || isNotLink) && !isAlwaysLink) {
			return (
				<span
					className={classNames(s.block, className)}
					onClick={onClick}
				>
					{props.children}
				</span>
			);
		}

		return isSimpleLink
			? <a href={String(url)} {...linkProps}>
				{props.children}
			</a>
			: React.createElement(ReactLink, {
				...linkProps,
				to: url,
			}, props.children);
	}

}

export const Link = LinkComponent;
